import { createFileRoute } from '@tanstack/react-router'
import { Trans, useLingui } from '@lingui/react/macro'
import { z } from 'zod'
import { zodValidator } from '@tanstack/zod-adapter'
import { AccessControlConfirmation } from '../-confirmation/access-control-confirmation'
import { TAKE_A_BREAK_TITLES } from '@/features/take-a-break/types'

const searchSchema = z.object({
  validTo: z.string().datetime(),
  type: z.enum([
    'H24',
    'H48',
    'D3',
    'D7',
    'D14',
    'D30',
    'D90',
    'TEST_1_MIN',
    'TEST_5_MIN',
  ]),
})

export const Route = createFileRoute(
  '/_app/your-play/access-controls/take-a-break-confirmation',
)({
  component: RouteComponent,
  validateSearch: zodValidator(searchSchema),
})

function RouteComponent() {
  const { i18n, t } = useLingui()
  const { type, validTo } = Route.useSearch()
  const date = i18n.date(validTo, {
    dateStyle: 'medium',
    timeStyle: 'short',
  })

  return (
    <AccessControlConfirmation
      heading={<Trans>You have successfully set a Take a Break</Trans>}
      description={
        <Trans>
          Your{' '}
          {{
            period: t(TAKE_A_BREAK_TITLES[type]),
          }}{' '}
          Take a Break has started and will end on {date}
        </Trans>
      }
    />
  )
}
